import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import IdfUpgradeDeviceBlockData from '../../../Models/Content/IdfUpgradeDeviceBlockData';
import IdfUpgradeDeviceMain from './IdfUpgradeDeviceMain';

export default class IdfUpgradeDeviceBlock extends EpiComponent<IdfUpgradeDeviceBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <IdfUpgradeDeviceMain context={this.getContext()} iContent={this.props.data} />;
  }
}
